import React, { useCallback, useEffect, useRef, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useUploadFileHook from "../../customHooks/useUploadFileHook";
import { toast } from "react-toastify";
import { UploadCloudIcon } from "lucide-react";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import APIS from "../../constant/Endpoint";
import { postApiData } from "../../helpers/AxiosInstance";
import { useQueryClient } from "@tanstack/react-query";

const DropFile = ({ data, setQrImage, setOpenQrUploadPopup }) => {
  const [isUploaded, setIsuploaded] = useState(true);
  const { uploadFile, progress } = useUploadFileHook({
    setIsuploaded,
    queryKey: ["file"],
  });

  const fileInputRef = useRef<HTMLInputElement>(null);
  const toastIdMap = useRef<Record<string, string | number>>({});
  const queryClient = useQueryClient();

  const generateFileId = () => {
    return (
      "file_" +
      Array.from(crypto.getRandomValues(new Uint8Array(16)))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("")
    );
  };

  const handleUpload = async (file: File) => {
    const fileId = generateFileId();

    toastIdMap.current[file.name] = toast.info(`Uploading ${file.name} (0%)`, {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    });

    await uploadFile(file, fileId, data?.id, data.title, () => {
      toast.update(toastIdMap.current[file.name], {
        render: `${file.name} uploaded successfully!`,
        type: "success",
        autoClose: 3000,
        isLoading: false,
      });
    });
  };

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(handleUpload);
  }, []);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    files.forEach(handleUpload);
  };

  useEffect(() => {
    Object.entries(toastIdMap.current).forEach(([fileName, toastId]) => {
      if (progress < 100) {
        toast.update(toastId as string | number, {
          render: `Uploading ${fileName}... ${progress.toFixed(0)}%`,
          type: "info",
          isLoading: false,
          autoClose: false,
        });
      }
    });
  }, [progress]);

  const handleQrGenerate = async () => {
    const url = APIS.GENERATE_QR;
    const formData = {
      id: data?.id,
    };
    try {
      const res = await postApiData({
        url,
        formData,
        responseType: "blob",
      });
      if (res?.status === 200) {
        const qrBlob = res.data;
        const qrUrl = URL.createObjectURL(qrBlob);
        setQrImage(qrUrl);
        setOpenQrUploadPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to generate QR");
    }
  };
  useEffect(() => {
    let interval: any;

    if (setOpenQrUploadPopup) {
      interval = setInterval(() => {
        queryClient.invalidateQueries({ queryKey: ["file"] });
      }, 3000); // every 3 sec
    }

    return () => clearInterval(interval);
  }, [setOpenQrUploadPopup]);

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
      className={tw`
        border-2 border-dashed border-gray-400 
        rounded-xl p-10 mt-4 text-center 
        bg-gray-50 hover:border-primary 
        transition-all duration-300 ease-in-out 
        cursor-pointer
      `}
    >
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        multiple
        onChange={handleFileChange}
      />
      {/* <FileUpload object_id={data?.id} /> */}
      <div className={tw`flex flex-col items-center gap-2`}>
        <UploadCloudIcon width={100} height={100} />
        <p className={tw`text-lg font-medium`}>Drop files here</p>
        <p className={tw`text-sm text-gray-500`}>or click to upload</p>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleQrGenerate();
          }}
          className={tw`
      mt-4 px-4 py-2 
      bg-blue-500 text-white 
      rounded-lg hover:bg-blue-600
      transition
    `}
        >
          Upload via QR
        </button>
      </div>
    </div>
  );
};

export default DropFile;

